import { Dispatch, SetStateAction, createContext } from "react";
import { Item } from "../../../../../utils/types/generals";
import { CardPayload, DatesDashboard, Loaders, Percentage } from "../provider";
import { dataIndicator } from "../components/cardIndicator";
import { FilterBody } from "../../../../../hooks/filter/typing";

export const DashboardContext = createContext<{
    items: Record<string, Item[] | boolean>
    loaders: Loaders
    porcentage: Percentage
    dates: DatesDashboard
    programmingData: Record<string, dataIndicator>
    actionPlanData: Record<string, dataIndicator>
    unitData: Record<string, dataIndicator>
    currentValueExisted: {
        units: boolean;
        programming: boolean;
        actionPlan: boolean;
    }
    graphicHistory: {
        here?: boolean;
        name: string;
        programming?: number;
        noProgramming?: number;
        total: number;
        paused?: number;
        noStarted?: number;
        finished?: number;
        canceled?: number;
    }[]
    getHistory: ({ name, unitList, filterData, filterByHistory }: {
        name: "units" | "programming" | "actionPlan";
        filterByHistory: {
            units: FilterBody;
            programming: FilterBody;
            actionPlan: FilterBody;
        };
    } & CardPayload) => Promise<void>
    setLoaders: Dispatch<SetStateAction<Loaders>>
    setItems: Dispatch<SetStateAction<Record<string, (Item)[] | boolean>>>
    getActionPlanData: ({ filterData, unitList, }: CardPayload) => Promise<void>
    getProgrammingData: ({ filterData, unitList, }: CardPayload) => Promise<void>
    getUnitsData: ({ filterData, unitList, }: CardPayload) => Promise<void>
}>(Object({}))